import {lazy} from 'react';
import GenericFallbackSuspense from '../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const Advertisement = lazy(() => (

  import('./Advertisement'/* webpackChunkName: 'Advertisement' */)
));

export default function AdvertisementLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <Advertisement {...props} />
    </GenericFallbackSuspense>
  );
}
